// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CarryingCost__DurationFieldWrapper {
  margin-bottom: 0.75rem;
  max-width: 10rem;
}
.CarryingCost__MonthlyHeader {
  padding-left: var(--padding-start, 10px);
}

::ng-deep .CarryingCost__DurationField ion-item {
  margin-left: -1rem;
  margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./apps/app/src/app/views/property-details/components/carrying-costs/carrying-costs.component.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,wCAAA;AADJ;;AAME;EACE,kBAAA;EACA,mBAAA;AAHJ","sourcesContent":[".CarryingCost {\n  &__DurationFieldWrapper {\n    margin-bottom: 0.75rem;\n    max-width: 10rem;\n  }\n\n  &__MonthlyHeader {\n    padding-left: var(--padding-start, 10px);\n  }\n}\n\n::ng-deep {\n  .CarryingCost__DurationField ion-item {\n    margin-left: -1rem;\n    margin-bottom: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
